import { render, staticRenderFns } from "./Ambulance800List.vue?vue&type=template&id=5f2fce9e&scoped=true&"
import script from "./Ambulance800List.vue?vue&type=script&lang=js&"
export * from "./Ambulance800List.vue?vue&type=script&lang=js&"
import style0 from "./Ambulance800List.vue?vue&type=style&index=0&id=5f2fce9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2fce9e",
  null
  
)

export default component.exports